<template>
</template>

<script>
export default {
    name: "StandaloneTaskRedirect",
    created() {
        let self = this;
        self.$router.push(
            process.env.VUE_APP_CONTEXT_PATH + "/standalone/secure/tasks/viewtask/" + self.$route.params.taskId
        );

    }
};
</script>
